// F167 (Tomas Pohl 2026-09-28): "chtěl bych, aby mi klienti z Launchpadu mohli
// napsat na Telegramu a nejen e-mailem." One place decides how a partner's
// Telegram identity turns into the link the client card opens.

/** "+420 777 123 456", "00420777123456" -> "+420777123456"; anything else -> null. */
export function normalizePhone(input: string): string | null {
  const compact = input.trim().replace(/[\s().-]/g, "").replace(/^00/, "+");
  return /^\+[1-9]\d{7,14}$/.test(compact) ? compact : null;
}

/**
 * The username link always works; the phone link opens the chat only when the
 * partner lets people find them by number in Telegram's privacy settings, so
 * the username wins whenever both exist.
 */
export function partnerTelegramUrl(username: string | null | undefined, phone: string | null | undefined): string | null {
  const handle = (username ?? "").trim().replace(/^@/, "");
  if (/^[A-Za-z][A-Za-z0-9_]{4,31}$/.test(handle)) return `https://t.me/${handle}`;
  const number = normalizePhone(phone ?? "");
  return number ? `https://t.me/${number}` : null;
}
